module.exports = __webpack_public_path__ + "images/graphic-footer_mobile@2x_7f09505215dd179efc3a6869344c3454.png";